import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, MessageCircleReply } from "lucide-react";
import { PulseHeader } from "./PollCard";
import { pulsesApi } from "../../lib/pulses";
import { formatApiError } from "../../lib/api";

export function TextCard({ pulse, onUpdate }) {
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const [words, setWords] = useState(pulse.payload.words || []);

  useEffect(() => {
    setWords(pulse.payload.words || []);
  }, [pulse.payload.words]);

  const submit = async (e) => {
    e && e.preventDefault();
    const w = word.trim();
    if (!w || busy) return;
    if (w.includes(" ")) {
      toast.error("Solo una palabra, sin espacios.");
      return;
    }
    if (w.length > 20) {
      toast.error("Máx. 20 caracteres.");
      return;
    }
    setBusy(true);
    try {
      const data = await pulsesApi.word(pulse.id, w);
      setWords(data.words);
      setWord("");
      onUpdate && onUpdate({ ...pulse, payload: { ...pulse.payload, words: data.words } });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <article
      className="q-glass rounded-3xl p-5 space-y-4"
      data-testid={`pulse-text-${pulse.id}`}
    >
      <PulseHeader pulse={pulse} kind="Micro-Text Canvas" />

      <div className="rounded-2xl border border-white/10 bg-black/25 px-4 py-5">
        <div
          className="font-display text-xl sm:text-2xl leading-snug text-slate-100"
          data-testid={`text-body-${pulse.id}`}
        >
          {pulse.payload.text}
        </div>
      </div>

      <div className="space-y-2">
        <div className="text-[11px] font-mono uppercase tracking-widest text-slate-500">
          Respuestas ({words.length})
        </div>
        <div className="flex flex-wrap gap-2" data-testid={`text-words-${pulse.id}`}>
          {words.length === 0 && (
            <span className="text-xs text-slate-500 italic">
              Aún nadie responde. Sé el primero.
            </span>
          )}
          {words.map((w) => (
            <span
              key={w.id}
              className="q-chip q-accent-text border-[color:var(--accent)]/30 bg-[color:var(--accent-soft)] font-mono"
              title={`@${w.ondatag}`}
              data-testid={`text-word-${w.id}`}
            >
              {w.word}
            </span>
          ))}
        </div>
      </div>

      <form onSubmit={submit} className="flex items-center gap-2">
        <input
          data-testid={`text-word-input-${pulse.id}`}
          className="q-input flex-1"
          placeholder="Responde con UNA palabra…"
          value={word}
          onChange={(e) => setWord(e.target.value.replace(/\s+/g, ""))}
          maxLength={20}
        />
        <button
          type="submit"
          disabled={busy || !word.trim()}
          data-testid={`text-word-submit-${pulse.id}`}
          className="q-btn-primary !px-4 !py-2.5 rounded-full inline-flex items-center gap-1"
        >
          {busy ? <Loader2 size={14} className="animate-spin" /> : <MessageCircleReply size={14} />}
        </button>
      </form>
    </article>
  );
}
